import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '~/redux/store'

interface FeedbackState {
  rating: number | null
  product: string | null
  contentId: string | null
  contentTitle: string | null
  contentSubtype: string | null
  showUserFeedbackModal: boolean
  comment: string
}

interface OpenUserFeedbackModalPayload {
  product: string
  contentId?: string | null
  contentTitle?: string | null
  contentSubtype?: string | null
}

const initialState: FeedbackState = {
  rating: null,
  product: null,
  contentId: null,
  contentTitle: null,
  contentSubtype: null,
  showUserFeedbackModal: false,
  comment: '',
}

const slice = createSlice({
  name: 'user-feedback',
  initialState,
  reducers: {
    setRating(state, action: PayloadAction<number>) {
      state.rating = action.payload
    },
    openUserFeedbackModal(state, action: PayloadAction<OpenUserFeedbackModalPayload>) {
      state.showUserFeedbackModal = true
      state.product = action.payload.product
      state.contentId = action.payload.contentId ?? null
      state.contentTitle = action.payload.contentTitle ?? null
      state.contentSubtype = action.payload.contentSubtype ?? null
    },
    closeUserFeedbackModal(state) {
      state.showUserFeedbackModal = false
    },
    setComment(state, action: PayloadAction<string>) {
      state.comment = action.payload
    },
    resetFeedbackState: () => initialState,
  },
})

export const getRating = (state: RootState): number | null => state.userFeedback.rating
export const getProduct = (state: RootState): string | null => state.userFeedback.product
export const getContentId = (state: RootState): string | null => state.userFeedback.contentId
export const getContentTitle = (state: RootState): string | null => state.userFeedback.contentTitle
export const getContentSubtype = (state: RootState): string | null => state.userFeedback.contentSubtype
export const getShowUserFeedbackModal = (state: RootState): boolean => state.userFeedback.showUserFeedbackModal
export const getComment = (state: RootState): string => state.userFeedback.comment

export const { setRating, openUserFeedbackModal, closeUserFeedbackModal, resetFeedbackState, setComment } =
  slice.actions

export default slice.reducer
